import { gql } from '@apollo/client';
import { COUNTRY_FIELDS } from 'graphql/common/fragments';

export const COUNTRIES_QUERY = gql`
  query countries($search: CountrySearchInput) {
    countries(search: $search) {
      ${COUNTRY_FIELDS}
      createdAt
      updatedAt
    }
  }
`;
